import React from 'react';
import styles from './ResultsCollapse.module.scss';
import { Result, ViewMode } from "../../types/SearchData";
import { viewModes } from '../../helpers/Const';
import CollapsibleResult from './CollapsibleResult';

interface ResultsCollapseProps {
    results: Result[];
    labels: { [key: string]: string };
    currentPage: number;
    selectedFilters: { [key: string]: string | string[] };
    selectedViewMode: ViewMode;
}

const ResultsCollapse: React.FC<ResultsCollapseProps> = ({ results, labels, currentPage, selectedFilters, selectedViewMode }) => {
    const isExpanded = selectedViewMode && selectedViewMode.mode == viewModes.Collapse ? selectedViewMode.isExpanded : false;
    
    return (
        <React.Fragment>
            <section className={`${styles["results-collapse"]} section`}>
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-4">
                        {results.map((result, index) => (
                            <div key={result.id} className="col-12 pt-2 pb-2 pr-0 pl-0">
                                <CollapsibleResult result={result} forceOpen={isExpanded} labels={labels} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default ResultsCollapse;